import { workspaceRequest } from "./workspaceApiShared";

export function getRental(rentalId, token) {
  return workspaceRequest(`/rentals/${rentalId}`, {
    token,
    fallback: "Unable to load workspace rental.",
  });
}

export function getRentalByBooking(bookingId, token) {
  return workspaceRequest(`/rentals/by-booking/${bookingId}`, {
    token,
    fallback: "Unable to load workspace rental for this booking.",
  });
}

export function getRentalAgreementSummary(rentalId, token) {
  return workspaceRequest(`/rentals/${rentalId}/agreement-summary`, {
    token,
    fallback: "Unable to load rental agreement summary.",
  });
}

export function getRentalAcceptedSnapshots(rentalId, token) {
  return workspaceRequest(`/rentals/${rentalId}/accepted-snapshots`, {
    token,
    fallback: "Unable to load accepted rental snapshots.",
  });
}

export function getRentalWarnings(rentalId, token) {
  return workspaceRequest(`/rentals/${rentalId}/warnings`, {
    token,
    fallback: "Unable to load rental warnings.",
  });
}

export function acknowledgeRentalWarning(rentalId, payload, token) {
  return workspaceRequest(`/rentals/${rentalId}/acknowledge-warning`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to acknowledge rental warnings.",
  });
}

export function acknowledgeRentalTerms(rentalId, payload, token) {
  return workspaceRequest(`/rentals/${rentalId}/acknowledge-terms`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to acknowledge rental terms.",
  });
}
